import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import { AttorneyService } from "../../../../services/ClientService";

import { useCallback } from "react";
import { Checkbox } from "@material-ui/core";

export default function AttorneyProfile({
    attorney,
}: {
    attorney: APIModels.Attorney;
}) {
    const [updatedAttorney, setUpdatedAttorney] = useState(attorney);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setUpdatedAttorney(attorney);
    }, [attorney]);

    const onSaveClick = useCallback(async () => {
        setSaving(true);
        AttorneyService.saveAutomation({
            attorneyId: attorney.id!,
            body: updatedAttorney,
        }).then(
            (resp) => {
                setSaving(false);
                if (resp.successful === true) {
                    setErrorMessage(resp.errorMessage ?? "");
                    attorney = { ...resp.data };
                } else {
                    console.log(resp.errorMessage);
                }
            },
            (error) => {
                setSaving(false);
                console.log(error);
                setErrorMessage("An error has occurred");
            }
        );
    }, [updatedAttorney]);

    return (
        <div className="card text-left">
            <div className="card-body">
                <h4 className="mb-3 bg-light p-2">Automation</h4>
                <div
                    className="row mb-3"
                    style={{
                        // display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div
                        className="col-lg-4"
                        style={{
                            display: "inline",
                            justifyContent: "center",
                        }}
                    >
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtHoldIncoming"
                                placeholder="HoldIncoming"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={updatedAttorney.holdIncoming ?? false}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        holdIncoming:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtHoldIncoming"
                                className="form-check-label"
                            >
                                Hold Incoming
                            </label>
                        </div>
                    </div>
                    <div
                        className="col-lg-3"
                        style={{
                            display: "inline",
                            justifyContent: "center",
                        }}
                    >
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtAllowOCR"
                                placeholder="AllowOCR"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={updatedAttorney.allowOCR ?? false}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        allowOCR: event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtAllowOCR"
                                className="form-check-label"
                            >
                                Allow OCR
                            </label>
                        </div>
                    </div>
                </div>
                <div
                    className="row mb-3"
                    style={{
                        // display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div
                        className="col-lg-4"
                        style={{
                            display: "inline",
                            justifyContent: "center",
                        }}
                    >
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtAutoFileExisting"
                                placeholder="Last Name"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={
                                    updatedAttorney.autoFileExisting ?? false
                                }
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        autoFileExisting:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtAutoFileExisting"
                                className="form-check-label"
                            >
                                AutoFile Existing
                            </label>
                        </div>
                    </div>
                    <div
                        className="col-lg-3"
                        style={{
                            display: "inline",
                            justifyContent: "center",
                        }}
                    >
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtAutoFileNew"
                                placeholder="AutoFileNew"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={updatedAttorney.autoFileNew ?? false}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        autoFileNew:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtAutoFileNew"
                                className="form-check-label"
                            >
                                AutoFile New
                            </label>
                        </div>
                    </div>
                    <div
                        className="col-lg-3"
                        style={{
                            display: "inline",
                            justifyContent: "center",
                        }}
                    >
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtUseBarcode"
                                placeholder="UseBarcode"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={updatedAttorney.useBarcode ?? false}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        useBarcode: event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtAutoFileNew"
                                className="form-check-label"
                            >
                                Use Barcode
                            </label>
                        </div>
                    </div>
                </div>
                <div className="mb-3 text-end">
                    {saving ? (
                        <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={true}
                        >
                            <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Saving...
                        </button>
                    ) : (
                        <button
                            className="btn btn-success waves-effect waves-light mt-2"
                            type="submit"
                            onClick={onSaveClick}
                        >
                            <i className="mdi mdi-content-save"></i>
                            Save
                        </button>
                    )}
                    <div>{errorMessage}</div>
                </div>
            </div>
        </div>
    );
}
